<template>
  <div>
    <p>Should the documentation relate to payments for:</p>
    <m-radio id="ratify" :options="selections" v-model="ratify" />
    <div
      v-if="ratify !== ''"
      class="mt-2 p-4 text-sm bg-blue-100 border border-blue-200 rounded space-y-2"
      v-html="selected.warning"
    ></div>
  </div>
</template>

<script>

const ratify = [
  {
    value: 'FULLYPROSPECTIVE',
    label: 'the whole financial year above and it will be signed before the year commences',
    warning: '<p>Some of the options for payments include partial commutations from pension accounts. These are only effective if the member requests (and the trustee agrees) to make the commutation before the payment is taken. Hence these documents should ideally be executed prior to the start of the financial year.</p><p>Use this option if the documents will be prepared, signed and dated before the financial year commences.</p>',
  },
  {
    value: 'FULLYRRATIFYING',
    label: 'the whole financial year above but it will be signed after the year commences to confirm verbal agreements made before the start of the year',
    warning: '<p>Some of the options for payments include partial commutations from pension accounts. These are only effective if the member requests (and the trustee agrees) to make the commutation before the payment is taken. Hence these documents should ideally be executed prior to the start of the financial year.</p><p>Use this option if the documents are intended to cover all payments taken throughout a financial year but won\'t be signed until after the start of the financial year. The documents will confirm verbal agreements made between the trustee and member(s) prior to the start of the financial year.</p>',
  },
  {
    value: 'PARTYRPROSPECTIVE',
    label: 'just part of the financial year because it is documenting arrangements made part way through the year after some payments have already been taken.',
    warning: '<p>Some of the options for payments include partial commutations from pension accounts. These are only effective if the member requests (and the trustee agrees) to make the commutation before the payment is taken.</p><p>Use this option if the documents are being prepared after some of the payments have already been made for the financial year and the member(s) and trustee haven\'t already agreed on their treatment.  The documents will only cover payments made after these documents are executed.</p>',
  },
];


export default {
  name: 'ratify-question',
  props: {
    selection: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ratify: '',
    };
  },
  computed: {
    selected() {
      return ratify.filter(item => this.ratify === item.label)[0];
    },
    selections() {
      return ratify.map(item => item.label);
    },
  },
  watch: {
    ratify() {
      this.$emit('ratify', this.selected);
    },
    selection: {
      immediate: true,
      handler(value) {
        this.ratify = value ? value.label : '';
      },
    },
  },
};
</script>
